import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

function ChartInfo(props) {
    const { post, chartTitle } = props;
    const data = [
                    {name: 'Page A', uv: 400, pv: 2400, amt: 2400},
                    {name: 'Page B', uv: 600, pv: 2800, amt: 2800},
                    {name: 'Page C', uv: 100, pv: 3400, amt: 3400},
                    {name: 'Page D', uv: 340, pv: 1400, amt: 1400},
                    {name: 'Page E', uv: 460, pv: 1800, amt: 1800},
                    {name: 'Page F', uv: 420, pv: 2000, amt: 2000},
                    {name: 'Page G', uv: 250, pv: 2100, amt: 2100}
                 
                ];
                // const data = [  
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                //     { category : "Dental",
                //       description: "How do you treat your toothpaste",
                //       docUrl : "https://firebasestorage.googleapis.com/v0/b/trackerapp-007.appspot.com/o/posts%2F34.jpg?alt=media&token=1fa0f649-7098-47dd-9395-a4af489f8f43",
                //       fileName : "34.jpg",
                //       id : "0sO2RlNMk7LWCwSCcg4C",
                //       name : "How do you treat your toothpaste",
                //       releaseDate : 1596495060000,
                //       status : "Released"
                //     },
                 
                // ];
                const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                const firstDate = new Date(2020, 1, 12);
                const secondDate = new Date(2020, 1, 22);
                
                const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
                // console.log(diffDays);  
                
                Date.prototype.addDay = function(days) { 
                    var date = new Date(this.valueOf()); 
                    date.setDate(date.getDate() + days); 
                    return date; 
                } 
                
            function createDateArray(firstDate,secondDate)  {  
                    var dArray = []; 
                    var cDate = firstDate; 
                    while (cDate <= secondDate) { 
                        
                        // Adding the date to array 
                        dArray.push({date: convertDate(new Date (cDate)), noOfPost:Math.floor(Math.random() * 100)});  
                        
                        // Increment the date by 1 day 
                        cDate = cDate.addDay(1);  
                    } 
                    return dArray; 
                }

                // const data = [
                //     {name: 'Page A', uv: 400, pv: 2400, amt: 2400},
                //     {name: 'Page B', uv: 600, pv: 2800, amt: 2800},
                //     {name: 'Page C', uv: 100, pv: 3400, amt: 3400},
                //     {name: 'Page D', uv: 340, pv: 1400, amt: 1400},
                //     {name: 'Page E', uv: 460, pv: 1800, amt: 1800},
                //     {name: 'Page F', uv: 420, pv: 2000, amt: 2000},
                //     {name: 'Page G', uv: 250, pv: 2100, amt: 2100}
                 
                // ];

                const dateArray = createDateArray(firstDate, secondDate);

                // console.log(dateArray);  
                function convertDate(inputFormat) {
                    function pad(s) { return (s < 10) ? '0' + s : s; }
                    var d = new Date(inputFormat)
                    return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
                  }
    return (
        <div>
            <BarChart width={600} height={300} data={dateArray}>
                <XAxis dataKey="date" /*scaleToFit={true} width={10} angle={-45}*/ stroke="#8884d8" label={{ value: 'Days', offset: 0, position: 'insideBottom' }} />
                <YAxis label={{ value: chartTitle, angle: -90, position: 'insideBottomLeft' }} />
                <Tooltip />
                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                <Bar dataKey="noOfPost" fill="#8884d8" barSize={30} />
            </BarChart>
        </div>
    )
}

export default ChartInfo
